import React, { useState } from 'react';
import { auth, db } from './firebase-config';
import { collection, addDoc } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import './AddJob.css';

const AddJob = () => {
  const [jobData, setJobData] = useState({
    title: '',
    company: '',
    description: '',
    requirements: '',
    location: 'Remote',
    jobType: 'Full-time',
    salary: '$50k-75k',
    industry: 'Technology',
    reasonsToJoin: []
  });

  const navigate = useNavigate();

  // Predefined options for dropdowns
  const locationOptions = ['Remote', 'On-site', 'Hybrid'];
  const jobTypeOptions = ['Full-time', 'Part-time', 'Contract', 'Internship'];
  const salaryRanges = [
    '$0-25k',
    '$25k-50k',
    '$50k-75k',
    '$75k-100k',
    '$100k-150k',
    '$150k-200k',
    '$200k+'
  ];
  const industryOptions = [
    'Technology',
    'Healthcare',
    'Finance',
    'Education',
    'Retail',
    'Manufacturing',
    'Marketing',
    'Sales',
    'Design',
    'Other'
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setJobData(prevData => ({
      ...prevData,
      [name]: value
    }));
  };

  const handleReasonsChange = (e) => {
    const reasons = e.target.value.split('\n').filter(reason => reason.trim() !== '');
    setJobData(prevData => ({
      ...prevData,
      reasonsToJoin: reasons
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const user = auth.currentUser;

    if (user) {
      try {
        const jobDoc = {
          employerId: user.uid,
          ...jobData,
          createdAt: new Date(),
          status: 'active',
          logo: 'https://via.placeholder.com/80',
          applicants: []
        };
        
        const jobRef = await addDoc(collection(db, 'jobs'), jobDoc);
        console.log('Job created successfully with ID:', jobRef.id);
        navigate('/employer-feed');
      } catch (error) {
        console.error('Error adding job:', error);
      }
    } else {
      console.error('No user is signed in');
    }
  };

  return (
    <div className="add-job-container">
      <div className="add-job-header">
        {/* <button onClick={() => navigate(-1)} className="back-button">
          ←
        </button> */}
        <h1 className="add-job-title">Post a New Job</h1>
      </div>
      
      <div className="add-job-card">
        <form onSubmit={handleSubmit} className="add-job-form">
          <div className="form-group">
            <label htmlFor="title">Job Title</label>
            <input
              type="text"
              id="title"
              name="title"
              className="form-input"
              value={jobData.title}
              onChange={handleChange}
              placeholder="e.g. Senior Software Engineer"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="company">Company Name</label>
            <input
              type="text"
              id="company"
              name="company"
              className="form-input"
              value={jobData.company}
              onChange={handleChange}
              placeholder="Your company name"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="jobType">Job Type</label>
            <select
              id="jobType"
              name="jobType"
              className="form-select"
              value={jobData.jobType}
              onChange={handleChange}
              required
            >
              {jobTypeOptions.map(type => (
                <option key={type} value={type}>{type}</option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="location">Location</label>
            <select
              id="location"
              name="location"
              className="form-select"
              value={jobData.location}
              onChange={handleChange}
              required
            >
              {locationOptions.map(location => (
                <option key={location} value={location}>{location}</option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="industry">Industry</label>
            <select
              id="industry"
              name="industry"
              className="form-select"
              value={jobData.industry}
              onChange={handleChange}
              required
            >
              {industryOptions.map(industry => (
                <option key={industry} value={industry}>{industry}</option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="salary">Salary Range</label>
            <select
              id="salary"
              name="salary"
              className="form-select"
              value={jobData.salary}
              onChange={handleChange}
              required
            >
              {salaryRanges.map(range => (
                <option key={range} value={range}>{range}</option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="description">Job Description</label>
            <textarea
              id="description"
              name="description"
              className="form-input"
              value={jobData.description}
              onChange={handleChange}
              placeholder="Describe the role and responsibilities"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="requirements">Requirements</label>
            <textarea
              id="requirements"
              name="requirements"
              className="form-input"
              value={jobData.requirements}
              onChange={handleChange}
              placeholder="List the required skills and qualifications"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="reasonsToJoin">Reasons to Join (one per line)</label>
            <textarea
              id="reasonsToJoin"
              name="reasonsToJoin"
              className="form-input"
              value={jobData.reasonsToJoin.join('\n')}
              onChange={handleReasonsChange}
              placeholder="List reasons why someone should join your company (one per line)"
              required
            />
          </div>

          <button type="submit" className="submit-btn">
            Post Job
          </button>
        </form>
      </div>
    </div>
  );
};

export default AddJob;
